import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { merge } from "rxjs";
import { tap } from "rxjs/operators";
import { Page } from "src/app/model/Page";
import { RegistrationModerationModel } from "src/app/model/RegistrationModerationModel";
import { ModerationService } from "src/app/services/moderation.service";
import { PushMlModalComponent } from "./push-ml-modal/push-ml-modal.component";

@Component({
  selector: "app-secure-moderation-list",
  templateUrl: "./moderation-list.component.html",
  styleUrls: ["./moderation-list.component.scss"],
})
export class ModerationListComponent implements OnInit, AfterViewInit {
  registrationModerationList: Page<RegistrationModerationModel>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<RegistrationModerationModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicantName",
    "createdOn",
    "moderationStatus",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  constructor(
    private router: Router,
    private moderationService: ModerationService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.loadData();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char) for ML", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    console.log('this.filterForm.value', this.filterForm.value, this.filterForm.value?.filterText, 
    this.filterForm.value?.filterText !== undefined);
    this.moderationService.fetchModerationList(this.currentPage, this.pageSize, 
      this.filterForm.value?.filterText != undefined ? 
      this.filterForm.value?.filterText
      : null
      ).subscribe((page) => {
        this.isLoading = false;
        console.log(page);
        this.registrationModerationList = page;
        this.dataSource = new MatTableDataSource(page.content);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = page.totalElements;
        });
        this.isSearchDisabled = false;
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
      }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  async pushToML() {
    const modal = await this.modalCtrl.create({
      component: PushMlModalComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
      
    if(role === 'submit') {
      
    }
  }

  viewClassForModerationStatus(moderationStatus: string) {
    if(moderationStatus === 'PENDING') {
        return 'bg-blue-400';
    }
    else if(moderationStatus === 'MAKER_APPROVED') {
        return 'bg-green-400';
    }
    else if(moderationStatus === 'MAKER_REJECTED') {
        return 'bg-pink-600';
    }
    else if(moderationStatus === 'CHECKER_APPROVED') {
        return 'bg-green-400';
    }
    else if(moderationStatus === 'CHECKER_REJECTED') {
        return 'bg-pink-600';
    } 
    else if(moderationStatus === 'INTERNAL_MODERATOR_APPROVED') {
      return 'bg-green-400';
    }
    else if(moderationStatus === 'INTERNAL_MODERATOR_REJECTED') {
        return 'bg-pink-600';
    } 
    else {
        return '';
    }
  }
}